import { render } from "./proporsi-status-pendaftaran.vue?vue&type=template&id=3ad41f68&scoped=true"
import script from "./proporsi-status-pendaftaran.vue?vue&type=script&lang=js"
export * from "./proporsi-status-pendaftaran.vue?vue&type=script&lang=js"

import "./proporsi-status-pendaftaran.vue?vue&type=style&index=0&id=3ad41f68&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad41f68"]])

export default __exports__